import Model from '@/models/Model'

export default class SlCustomerBranchOffice extends Model {
    resource() {
        return 'sl_customer_branch_offices'
    }
}
